export { initConfig, setAppConfig } from "./actions";
export { default as reducer } from "./reducer";

import { ConfigState as TConfigState } from "./types";
export type ConfigState = TConfigState;
